import config from '@/common/config';

export default function GlobalErrorHandler() {
    return {
        install(Vue, {store}) {
            // link: https://vuejs.org/v2/api/#errorCaptured
            Vue.config.errorHandler = (error, vm, info) => {
                const {VUE_APP_INTERCOM_ID} = config;
                if (VUE_APP_INTERCOM_ID) {
                    store.dispatch('triggerIntercomEvent', {
                        name: `Unexpected Javascript Error`,
                        meta: {
                            info,
                            error,
                        },
                    });
                }
                throw error;
            };
        },
    };
}
